export const FALLBACK_ASSETS_BASE_URL = "https://cabin.sbgtv.tech/assets";
export const CHESS_URL = "https://chess.sbgtv.tech";
export const GAMES_LAUNCHER_URL = "https://int.games.sbgtv.tech";

export type Direction = "right" | "left" | "up" | "down";

export const DIRECTIONS = ["right", "left", "up", "down"] as const;

export const REVERSE_DIRECTION_MAPPING = {
	left: "right",
	right: "left",
	down: "up",
	up: "down",
} as const;

export const GESTURE_EVENTS: (keyof WindowEventMap)[] = [
	"keydown",
	"click",
	"touchstart",
	"touchend",
	"pointerdown",
	"mousemove",
] as const;
// https://developer.chrome.com/blog/autoplay
export const CHROME_AUTOPLAY_EVENTS: (keyof WindowEventMap)[] = [
	"keydown",
	"click",
	"touchstart",
	"touchend",
	"pointerdown",
] as const;
